import { ANONYMOUS_NAME, ANONYMOUS_USER_EMAIL, AnyType } from '@thehubz/shared/model';

export function isUserLocked(user: AnyType): boolean {
  if (user.email === ANONYMOUS_USER_EMAIL && user.username === ANONYMOUS_NAME) return false;
  return user?.failedLoginAttempts && user.failedLoginAttempts >= 5;
}

export function attemptsLeft(failedLoginAttempts: number): number {
  return Math.max(0, 5 - failedLoginAttempts);
}
